// extracted by mini-css-extract-plugin
export default {"nft":"AssetItemList_nft__lOXDd","nft__image":"AssetItemList_nft__image__0LCYN","nft__name":"AssetItemList_nft__name__EcmiB"};